/*
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-07 11:29:35
 * @LastEditors: may.li
 * @LastEditTime: 2023-06-12 11:42:00
 */
/**
  * 用户 接口的统一出口
  */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
const index = {
	// 已代理的匠人
	tradesman(params){
		return axios.get("/home/agent/tradesman/list", { params: params });
	},
	// 二级分销商为商家绑定二维码，输入二维码编号或者扫码
	tradqrcode(params){
		return axios.post('/home/agent/trad/qrcode', qs.stringify(params));
	},
	// 商铺中心商品列表或者二级分销商获取可以分销的商品
	tradGoods(params){
		return axios.get("/home/tradcenter/goods", { params: params });
	},
	// 推送到二级分销商云平台
	pushGoods(params){
		return axios.post("/home/agent/fxgoods/push", qs.stringify(params));
	},
	// 商家中心或者二级分销商可以分销的定制商品
	tradMades(params){
		return axios.get("/home/agent/fxmades/list", { params: params });
	},
	// 推送定制到二级分销商云平台
	pushMades(params){
		return axios.post('/home/agent/fxmades/push', qs.stringify(params));
	},
	// 分销商推荐匠人
	tuijianTradesman(params){
		return axios.post('/home/user/agent/tradesmanpush', qs.stringify(params));
	},
	// 分销商给商家排序
	sortTradesman(params){
		return axios.post('/home/user/agent/tradesmansort', qs.stringify(params));
	},
	// 一级分销商获取业务员
	salesman(params){
		return axios.get("/home/firstagent/salesman/list", { params: params });
	},
	// 一级分销商添加业务员
	createsaleman(params){
		return axios.get("/home/firstagent/createsaleman", { params: params });
	},
	// 二级分销商 获取二维码
	agnetQrcodes(params){
		return axios.get("/home/agent/qrcodes", { params: params });
	},
	// 二级分销商 二维码详情
	agnetQrcodedetail(params){
		return axios.get("/home/agent/qrcodedetail", { params: params });
	}
}
// 导出接口
export default index